import { lazy } from 'react';
import { createRoute } from './utils';

// Lazy load the NotFound component
const NotFound = lazy(() => import('@/pages/NotFound'));

// NotFound route (catch-all for 404 errors)
export const notFoundRoute = createRoute('*', <NotFound />, 'Page Not Found');
